module.exports = __webpack_public_path__ + "b69f538f56366e74e424459f06771b81.pdf";